import Api from '@/api'

export default {
  namespaced: true,

  actions: {
    async sendFileShare({ commit }, payload) {
      const { data } = await Api.post(
        `file/${payload.fileId}/share`,
        payload.formData
      ).catch(err => {
        throw err
      })

      return data
    },

    async revokeFileShareEmail({ commit }, payload) {
      const { data } = await Api.post(
        `file/${payload.fileId}/share-revoke`,
        payload.formData
      ).catch(err => {
        throw err
      })

      return data
    }
  }
}
